// Static data: 88-key color map and interval definitions
import type { IntervalData } from './types';

// Sheet 1: 88-key color map (MIDI 21-108)
export const COLORS: Record<number, [string, string]> = {
  21: ["A0","#470066"], 22: ["A#0","#990099"], 23: ["B0","#99004d"], 24: ["C1","#990000"],
  25: ["C#1","#994d00"], 26: ["D1","#994d00"], 27: ["D#1","#997300"], 28: ["E1","#999900"],
  29: ["F1","#4d9900"], 30: ["F#1","#8FBC8F"], 31: ["G1","#191970"], 32: ["G#1","#4B0082"],
  33: ["A1","#9400D3"], 34: ["A#1","#FF1493"], 35: ["B1","#8B008B"], 36: ["C2","#8B0000"],
  37: ["C#2","#8B3100"], 38: ["D2","#CC5500"], 39: ["D#2","#8c7122"], 40: ["E2","#DAA520"],
  41: ["F2","#228B22"], 42: ["F#2","#3CB371"], 43: ["G2","#5F9EA0"], 44: ["G#2","#00008B"],
  45: ["A2","#483D8B"], 46: ["A#2","#9932CC"], 47: ["B2","#FF00FF"], 48: ["C3","#FF2400"],
  49: ["C#3","#ff6400"], 50: ["D3","#FFA500"], 51: ["D#3","#FFa400"], 52: ["E3","#FFDD33"],
  53: ["F3","#008000"], 54: ["F#3","#339966"], 55: ["G3","#0066cc"], 56: ["G#3","#751aff"],
  57: ["A3","#9933ff"], 58: ["A#3","#cc33ff"], 59: ["B3","#ff33cc"], 60: ["C4","#ff3333"],
  61: ["C#4","#ff6633"], 62: ["D4","#ff9933"], 63: ["D#4","#ffcc33"], 64: ["E4","#ffff33"],
  65: ["F4","#66ff33"], 66: ["F#4","#33ffcc"], 67: ["G4","#3366ff"], 68: ["G#4","#3333ff"],
  69: ["A4","#bf80ff"], 70: ["A#4","#ff80df"], 71: ["B4","#ff809f"], 72: ["C5","#ff8080"],
  73: ["C#5","#ff9f80"], 74: ["D5","#ffbf80"], 75: ["D#5","#ffdf80"], 76: ["E5","#ffff80"],
  77: ["F5","#9fff80"], 78: ["F#5","#80ffdf"], 79: ["G5","#80bfff"], 80: ["G#5","#8080ff"],
  81: ["A5","#e6ccff"], 82: ["A#5","#ffccff"], 83: ["B5","#ffcce6"], 84: ["C6","#ffcccc"],
  85: ["C#6","#ffd9cc"], 86: ["D6","#ffe6cc"], 87: ["D#6","#ffffcc"], 88: ["E6","#f2ffcc"],
  89: ["F6","#ccffcc"], 90: ["F#6","#ccffff"], 91: ["G6","#cce6ff"], 92: ["G#6","#ccccff"],
  93: ["A6","#f2e6ff"], 94: ["A#6","#ffe6ff"], 95: ["B6","#ffe5ec"], 96: ["C7","#ffe6e6"],
  97: ["C#7","#ffece5"], 98: ["D7","#fff9e5"], 99: ["D#7","#ffffe5"], 100: ["E7","#f2ffe5"],
  101: ["F7","#e5ffe5"], 102: ["F#7","#e5ffff"], 103: ["G7","#e5f2ff"], 104: ["G#7","#e5e5ff"],
  105: ["A7","#ece5ff"], 106: ["A#7","#f9e5ff"], 107: ["B7","#ffe5f9"], 108: ["C8","#ffe5ec"]
};

// Sheet 2: intervals -> shape + harmonic blend weight
export const INTERVALS: Record<number, IntervalData> = {
  2:  { name: "Second",  shape: "2",      d3: "Pyramid",         semis: [1, 2],       blend: 0.47 },
  3:  { name: "Third",   shape: "3",      d3: "Pentahedron",     semis: [3, 4],       blend: 0.45 },
  4:  { name: "Fourth",  shape: "4",      d3: "Cube",            semis: [5, 6],       blend: 0.43 },
  5:  { name: "Fifth",   shape: "5",      d3: "Polyhedron",      semis: [7, 8],       blend: 0.40 },
  6:  { name: "Sixth",   shape: "6",      d3: "Hexagonal Prism", semis: [9],          blend: 0.42 },
  7:  { name: "Seventh", shape: "7",      d3: "Heptagram",       semis: [10, 11],     blend: 0.46 },
  12: { name: "Octave",  shape: "sphere", d3: "Sphere",          semis: [12, 24, 36], blend: 0.33 },
};

export const NOTE_NAMES = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];

export const INTERVAL_LABELS: Record<number, string> = {
  0: 'Unison', 1: 'm2', 2: 'M2', 3: 'm3', 4: 'M3', 5: 'P4', 6: 'Tritone',
  7: 'P5', 8: 'm6', 9: 'M6', 10: 'm7', 11: 'M7', 12: 'Octave'
};